__turbopack_context__.v({
  "button": "go-to-top-module-scss-module__akBwQq__button",
});
